import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";

@Component({
	selector: 'pregled-pregleda',
	templateUrl: './pregled-pregleda.component.html',
	styleUrls: ['./pregled-pregleda.component.css']
})
export class PregledPregledaComponent implements OnInit {
	@Input() idAuta;
	@Input() nazivProizvodjaca;
	@Input() regBroj;

	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	ngOnInit() {
		this.ucitaj();
	}

	server_data: any = null;
	loading = false;
	msg: any;
	pregledi: any = [];
	currentView = 'main';
	odabraniPregledId: any = null;
	odabraniPregledBrisi : any = null;

	ucitaj() {

		this.loading = true;
		this.http.get('vlasnici/automobili/pregled', { params: { idAuto: this.idAuta } })
			.subscribe(data => {
				this.loading = false;
				this.pregledi = data;
			}
				, error => {
					this.loading = false;
				});
	}

	cancel() {
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	onCancelPregled(data) {
		this.currentView = 'main';
	}

	dodajPregled() {
		this.odabraniPregledId = null;
		this.currentView = 'pregled';
	}

	izmijeniPregled(pregled) {
		this.odabraniPregledId = pregled.id;
		this.currentView = 'pregled';
	}

	onInsertPregled(pregled) {
		this.currentView = 'main';

		if (this.odabraniPregledId) {
			let index = this.pregledi.findIndex((item) => item.id == this.odabraniPregledId);
			if (index >= 0)
				this.pregledi[index] = pregled;
		}
		else
			this.pregledi.unshift(pregled);

		this.odabraniPregledId = null;
	}

	zapisnik(pregled, vrsta) {
		this.loading = true;
		let url = 'pregled/zapisnik';

		if(vrsta == 'AD')url = 'pregled/zapisnikAD';

		this.http.get(url, { params: { 'idPregleda': pregled.id }, responseType: 'blob' })
			.subscribe(
				data => {
					this.loading = false;
					this.globalSrvc.openBlob(data, 'word');
				},
				error => {
					this.loading = false;
					window.alert('Došlo je do greške prilikom generisanja rang liste');
				});
	}

	obrisi(pregled){
		this.odabraniPregledBrisi = pregled; 
		this.currentView = 'main';
		var elem = document.getElementById('modalBrisiPregled');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}

	obrisiPregled(){
		let url = 'vlasnici/vozilo/pregled/brisi';
		 let obj = {id : this.odabraniPregledBrisi.id};
		
		this.loading = true;
		
		setTimeout(() => {				
		
			this.http.post(url, obj)
				.subscribe(data => {
					this.msg = data;
					//console.log(data);
					this.loading = false;

					if (this.msg.id == 1) {
						this.ucitaj();
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 2000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}

	uvjerenje(pregled){
        //console.log(this.ucenik);
        this.loading = true;
        let url = 'getReport/uvjerenje';
        
        this.http.get(url, {params : {'idPregleda' : pregled.id}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'pdf');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }
}